import { ConsultaPrevia } from "./ConsultaPrevia";

export default ConsultaPrevia;